export enum BasketHubEvents {
  BASKET__UPDATE = "NotifyBasketUpdate",
}
